import { render } from "./zxzb.vue?vue&type=template&id=1b8f7a53&scoped=true&ts=true"
import script from "./zxzb.vue?vue&type=script&lang=ts"
export * from "./zxzb.vue?vue&type=script&lang=ts"

import "./zxzb.vue?vue&type=style&index=0&id=1b8f7a53&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8f7a53"]])

export default __exports__